module.exports = __webpack_public_path__ + "media/images/categories/carousel/finance-and-money-c8f463108a278cf414221f811f35d4eb.jpg";